import { CognitoUser, CognitoUserPool } from "amazon-cognito-identity-js";
import { COGNITO_CLIENT_ID, COGNITO_POOL_ID } from "constants/global";

export class Auth {
	static cognitoUser: CognitoUser;
	static userPool: CognitoUserPool;

	/**
	 * @description Initializes CognitoUserPool and CognitoUser based on username and poolData.
	 * @param username
	 */
	init(username: string) {
		const poolData = {
			UserPoolId: COGNITO_POOL_ID,
			ClientId: COGNITO_CLIENT_ID
		};
		Auth.userPool = new CognitoUserPool(poolData);
		Auth.cognitoUser = new CognitoUser({
			Username: username,
			Pool: Auth.userPool
		});
	}

	/**
	 *
	 * @returns cognito user
	 */
	getCognitoUser() {
		return Auth.cognitoUser;
	}

	/**
	 *
	 * @returns cognito user pool
	 */
	getUserPool() {
		return Auth.userPool;
	}
}
